/**
 * Discovery-aligned Luminate Artists filter toggles.
 * Checked = filter ON (matches multiweek discovery intent).
 */
import DiscoveryFilterToolbar from './DiscoveryFilterToolbar'

export const DEFAULT_LUMINATE_ARTIST_DISCOVERY_FILTERS = {
  applyPctChgMin: true,
  applyWeeksUpMin: true,
  applyFocusCountryLang: true,
  applyFocusGenres: true,
  applyAtdMax: true,
}

const FILTER_ITEMS = [
  {
    key: 'applyPctChgMin',
    label: '% Chg TW ≥ −10%',
    title: 'Most recent week WoW % Chg TW; blank % Chg (missing prior week) kept',
  },
  {
    key: 'applyWeeksUpMin',
    label: '# Weeks Up ≥ 2',
    title: 'Trailing # Weeks Up streak (dip-forgiven) at least 2',
  },
  {
    key: 'applyFocusCountryLang',
    label: 'Focus Country-Lang',
    title:
      'Same as multiweek Excel: focus country set and blank/English/Spanish/Yoruba languages',
  },
  {
    key: 'applyFocusGenres',
    label: 'Focus Genres',
    title:
      'Luminate Genres starts with Afrobeats, Alternative, Country, Folk, Indie Rock, Latin, Pop, Punk, R&B, Rap, or Rock',
  },
  {
    key: 'applyAtdMax',
    label: 'Streams ATD ≤ 20M',
    title: 'Drop artists with Streams ATD over 20M; blank ATD kept',
  },
]

export default function LuminateArtistDiscoveryFilters({
  filters,
  onChange,
  hideNonEnglish,
  onHideNonEnglishChange,
}) {
  return (
    <DiscoveryFilterToolbar
      filters={filters}
      onChange={onChange}
      defaultFilters={DEFAULT_LUMINATE_ARTIST_DISCOVERY_FILTERS}
      items={FILTER_ITEMS}
      hideNonEnglish={hideNonEnglish}
      onHideNonEnglishChange={onHideNonEnglishChange}
      hideNonEnglishTitle="Hide rows whose Name contains non-English characters"
    />
  )
}
